import * as React from "react";

import { RouteComponentProps } from "react-router";
import { Card, CardBody, CardFooter, Col, Container, Row } from "reactstrap";
import WelcomeForm from "./WelcomeForm";

type OwnProps =
    RouteComponentProps<{
        token: string;
    }>

interface accountState {
    isLoading: boolean;
}
export class Welcome extends React.Component<OwnProps> {
    public state: accountState = {
        isLoading: false,
    };

    constructor(props: Readonly<OwnProps>) {
        super(props);
    }
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.ensureDataFetched();
    }

    private ensureDataFetched() {

    }
    public render() {
        return (
            <Container>
                <Row>
                    <Col />
                    <Col lg="8">
                        <Container>
                            <h3>
                            Frontier CABS Bill Portal
                            </h3>
                            <hr />
                            <Card>
                                <CardBody>
                                    <WelcomeForm />

                                </CardBody>
                                <CardFooter>
                                   
                                </CardFooter>
                            </Card>
                        </Container>
                    </Col>
                    <Col />
                </Row>
            </Container>
        );
    }
}
